<template class="notice-log-container">
  <div class="view-point-app-container" style="position: relative; height: 100%; padding: 10px">
    <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="'任務維護'"
      :visible.sync="dialogVisible"
      width="63%"
    >
      <el-card class="box-card">
        <el-form
          ref="form"
          :model="taskForm"
          :label-width="formLabelWidth"
          v-loading="branchLoading"
        >
          <el-form-item :label="'發佈日期'">
            <el-tag>{{ taskForm.deployDate }}</el-tag>
          </el-form-item>

          <el-form-item
            :label="'目標環境'"
            prop="env"
            :rules="[{ required: true, message: '請選擇目標環境', trigger: 'change' }]"
          >
            <el-select
              v-model="taskForm.env"
              placeholder="請選更新類型"
              class="header-search-select"
              default-first-option
            >
              <el-option
                v-for="item in envOptions"
                :key="item.id"
                :value="item.id"
                :label="item.desc"
              >
                <span style="float: left">
                  <i class="el-icon-edit"></i>
                </span>
                <span :style="{ float: 'right', color: item.color, 'font-size': '13px' }">{{
                  item.desc
                }}</span></el-option
              >
            </el-select>
          </el-form-item>

          <el-form-item
            :label="'儲存庫(Repo)'"
            prop="repo"
            :rules="[{ required: true, message: '請選擇儲存庫', trigger: 'change' }]"
          >
            <el-select
              v-model="taskForm.repo"
              filterable
              placeholder="請選取儲存庫"
              class="header-search-select"
              default-first-option
              @change="onRepoChange"
            >
              <el-option v-for="item in repos" :key="item" :value="item" :label="item" />
            </el-select>
          </el-form-item>

          <el-form-item
            :label="'分支(branch)'"
            prop="branch"
            :rules="[{ required: true, message: '請選擇分支', trigger: 'change' }]"
          >
            <el-select
              v-model="taskForm.branch"
              filterable
              placeholder="請選取分支"
              class="header-search-select"
              @change="onBranchChange"
              value-key="name"
            >
              <el-option
                v-for="item in branchOptions"
                :key="item.name"
                :value="item"
                :label="item.name"
              />
            </el-select>
            <el-button
              style="cursor: pointer; margin-left: 10px"
              :loading="branchLoading"
              type="success"
              icon="el-icon-refresh-left"
              circle
              @click="getBranchs(taskForm.repo)"
            ></el-button>
          </el-form-item>

          <el-form-item
            :label="'服務(Service)'"
            prop="service"
            :rules="[{ required: true, message: '請選擇服務', trigger: 'change' }]"
          >
            <el-select
              v-model="taskForm.service"
              filterable
              placeholder="請選取服務"
              class="header-search-select"
              default-first-option
            >
              <el-option v-for="item in serviceOptions" :key="item" :value="item" :label="item" />
            </el-select>
          </el-form-item>

          <el-form-item :label="'sha'">
            <el-input
              class="readonly-input"
              readonly
              v-model="taskForm.sha"
              placeholder="Git Commit sha"
              style="width: 70%"
            >
            </el-input>
          </el-form-item>

          <el-form-item :label="'Commit Info'">
            <el-descriptions title="" v-if="branchInfo" direction="vertical" :column="3" border>
              <el-descriptions-item label="branch">{{ branchInfo.branch }}</el-descriptions-item>
              <el-descriptions-item label="committer">{{
                branchInfo.committer
              }}</el-descriptions-item>
              <el-descriptions-item label="date">{{ branchInfo.date }}</el-descriptions-item>
              <el-descriptions-item label="message">
                <el-tag size="small">{{ branchInfo.message }}</el-tag>
              </el-descriptions-item>
            </el-descriptions>
          </el-form-item>

          <el-form-item label="發佈類型">
            <el-row type="flex" class="row-bg">
              <el-col :span="7">
                <el-select
                  v-model="taskForm.deployType"
                  placeholder="請選更新類型"
                  class="header-search-select"
                  default-first-option
                >
                  <el-option
                    v-for="item in deployTypeOptions"
                    :key="item.id"
                    :value="item.id"
                    :label="item.desc"
                  />
                </el-select>

                <!-- <el-switch v-model="taskForm.deployType" active-text="預定更新" inactive-text="立即更新" :inactive-value="1"
                  :active-value="2">
                </el-switch> -->
              </el-col>
              <el-col :span="15">
                <div v-if="taskForm.deployType == 2">
                  <!-- <el-button @click="setMorning">上午时段</el-button>
                  <el-button @click="setAfternoon">下午时段</el-button>
                  <el-button @click="setEvening">晚上时段</el-button> -->

                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    :picker-options="datePickerOptions"
                    v-model="taskForm.deployDate"
                    type="date"
                    placeholder="預定日期"
                  >
                  </el-date-picker>

                  <el-time-select
                    v-model="taskForm.deployTime"
                    :picker-options="timePickOptions"
                    placeholder="選擇時間"
                  >
                  </el-time-select>
                </div>

                <div v-if="taskForm.deployType == 3">
                  <span style="margin-right: 5px">每日</span>
                  <el-time-select
                    v-model="taskForm.deployTime"
                    :picker-options="{
                      start: '00:00',
                      step: '00:10',
                      end: '23:50',
                    }"
                    placeholder="選擇時間"
                  >
                  </el-time-select>
                </div>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button :type="taskForm.id ? 'success' : 'primary'" @click="saveData">{{
          taskForm.id ? '再次執行' : '確 定'
        }}</el-button>
        <el-button type="danger" @click="dialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0">
      <el-form style="display: flex; align-items: flex-end; gap: 0 8px" label-position="left">
        <el-form-item>
          <el-button
            style="cursor: pointer"
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh()"
          ></el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="addData" icon="el-icon-plus"
            >新增任務</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="觸發來源" width="80">
          <template slot-scope="scope">
            <el-tag effect="plain" :type="scope.row.triggeredBy == 'ita' ? 'success' : 'danger'">{{
              scope.row.triggeredBy
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="left" label="日期" width="120">
          <template slot-scope="scope">
            {{ scope.row.deployDate }} {{ scope.row.deployTime }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="狀態" width="110">
          <template slot-scope="scope">
            <el-tag
              v-if="!getProcessHandler(scope.row.deployTaskProcess, 'message')"
              :type="scope.row.status | statusFilter"
              ><span> {{ scope.row.status | statusDescFilter }}</span></el-tag
            >

            <el-button
              v-else
              size="mini"
              type="danger"
              :disabled="false"
              @click="alertErrorMsg(scope.row)"
            >
              {{ scope.row.status | statusDescFilter }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" label="環境">
          <template slot-scope="scope">{{ scope.row.env }} </template>
        </el-table-column>

        <el-table-column align="center" label="儲存庫" width="130">
          <template slot-scope="scope">
            {{ scope.row.repository }}
          </template>
        </el-table-column>

        <el-table-column align="left" label="分支" width="130">
          <template slot-scope="scope">
            {{ scope.row.branch }}
          </template>
        </el-table-column>

        <el-table-column align="left" label="服務" width="200">
          <template slot-scope="scope">
            {{ scope.row.service }}
          </template>
        </el-table-column>

        <!-- <el-table-column align="left" label="sha" width="300">
          <template slot-scope="scope">
            {{ scope.row.sha }} </template>
        </el-table-column> -->

        <el-table-column align="center" label="發佈類型" width="130">
          <template slot-scope="scope">
            <el-tag :type="scope.row.deployType | statusFilter"
              ><span>{{
                deployTypeOptions.find(option => option.id === scope.row.deployType).desc
              }}</span></el-tag
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="Process" width="300">
          <template slot-scope="scope">
            <table border="1" class="custom-table">
              <tr>
                <th>checkout</th>
                <th>publish</th>
                <th>deploy</th>
                <th>updated</th>
              </tr>
              <tr>
                <td style="text-align: center">
                  <i
                    class="el-icon-check process-checked"
                    v-if="getProcessHandler(scope.row.deployTaskProcess, 'checkout')"
                  ></i>
                </td>

                <td style="text-align: center">
                  <i
                    class="el-icon-check process-checked"
                    v-if="getProcessHandler(scope.row.deployTaskProcess, 'publish')"
                  ></i>
                </td>
                <td style="text-align: center">
                  <i
                    class="el-icon-check process-checked"
                    v-if="getProcessHandler(scope.row.deployTaskProcess, 'deploy')"
                  ></i>
                </td>

                <td style="text-align: center">
                  <span v-if="getProcessHandler(scope.row.deployTaskProcess, 'updated')">
                    <i class="el-icon-check process-checked"></i>
                  </span>

                  <span
                    v-if="
                      scope.row.deployType == 0 &&
                      getProcessHandler(scope.row.deployTaskProcess, 'deploy') &&
                      !getProcessHandler(scope.row.deployTaskProcess, 'updated') &&
                      scope.row.status == 1
                    "
                  >
                    <el-button
                      size="mini"
                      type="success"
                      :disabled="false"
                      @click="updated(scope.row)"
                      >更新</el-button
                    >
                  </span>

                  <span v-if="scope.row.deployType == 2 && scope.row.status != 3">
                    <i class="el-icon-timer process-checked"></i>
                  </span>
                </td>
              </tr>
            </table>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" :disabled="false" @click="editData(scope.row)"
              >編輯</el-button
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="建立時間" width="180">
          <template slot-scope="scope">
            {{ scope.row.buildDate.replace('T', ' ') }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="建立者" width="140">
          <template slot-scope="scope">
            {{ scope.row.buildExecutor }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="guid" width="260">
          <template slot-scope="scope">
            {{ scope.row.guid }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="更新時間" width="180">
          <template slot-scope="scope">
            {{ scope.row.updateDate.replace('T', ' ') }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="更新者" width="140">
          <template slot-scope="scope">
            {{ scope.row.updateExecutor }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
// import NotificationSetting from "@/views/ita/appManage/components/notificationSetting.vue";
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'
import {
  getDeployTaskList,
  getBranchs,
  getBranch,
  saveTaskData,
  GetAllServicesInRepository,
  doUpdated,
} from '@/api/deploy'

function isToday(dateString) {
  if (!dateString) {
    return false
  }

  const currentDate = getTodayDate()
  const inputDateObj = new Date(dateString)
  const currentDateObj = new Date(currentDate)

  return inputDateObj.toISOString().split('T')[0] === currentDateObj.toISOString().split('T')[0]
}

function getTodayDate() {
  return new Date().toISOString().split('T')[0]
}

var defaultForm = {
  id: null,
  env: 1,
  repo: 'ita.GroupTravel',
  service: '',
  branch: null,
  sha: '',
  deployType: 0,
  deployDate: '',
  deployTime: '',
}

export default {
  name: 'DeployTask',
  components: {
    Pagination,
  },
  data() {
    return {
      pickerOptions: {
        disabledHours: () => [],
        disabledMinutes: () => [],
        disabledSeconds: () => [],
      },
      funcName: '自動更版任務',
      dialogTopMargin: '2%',
      formLabelWidth: '130px',
      repos: ['ita.GroupTravel'],
      deployTypeOptions: [
        { id: 0, desc: '預備更新' },
        { id: 1, desc: '立即更新' },
        { id: 2, desc: '排程更新' },
      ],
      envOptions: [
        { id: 1, desc: '開發區(Development)', color: '#8492a6' },
        { id: 2, desc: '測試區(Test)', color: '#8492a6' },
        { id: 3, desc: '正式區(Production)', color: 'coral' },
      ],
      taskForm: {},
      originalFormData: {},
      branchLoading: false,
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      branchInfo: null,
      branchOptions: [],
      serviceOptions: [],
      listQuery: {
        fcmType: null,
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      total: 0,
      list: [],
      fcmTypeOption: [],
      datePickerOptions: {
        onPick: obj => {
          // this.selectedBeginDate = new Date(obj.minDate).getTime();
          // this.selectedEndDate = new Date(obj.maxDate).getTime();
        },
        disabledDate: time => {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      timePickOptions: {
        start: '00:00',
        step: '00:10',
        end: '23:50',
      },
    }
  },
  watch: {
    'taskForm.deployDate': {
      handler: function (newVal, oldVal) {
        let vm = this
        if (newVal != oldVal) {
          let { start } = vm.timePickOptionsFunc()
          this.taskForm.deployTime = start
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  filters: {
    statusFilter(status) {
      const statusMap = {
        0: 'info',
        1: 'warning',
        2: '',
        3: 'success',
        4: 'danger',
      }
      return statusMap[status]
    },
    statusDescFilter(status) {
      const statusMap = {
        0: '未知狀態',
        1: '閒置',
        2: '處理中',
        3: '處理完成',
        4: '失敗',
      }
      return statusMap[status]
    },
  },
  async created() {
    await this.getList()
    this.taskForm = defaultForm
    //預設日期時間
    let today = getTodayDate()
    this.taskForm.deployDate = today

    let { start } = this.timePickOptionsFunc()
    this.taskForm.deployTime = start
    await this.onRepoChange(this.taskForm.repo)
  },
  methods: {
    async refresh() {
      this.listQuery = {
        fcmType: null,
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      await this.getList()
    },
    timePickOptionsFunc() {
      const currentDate = getTodayDate()
      let chkDate = this.taskForm.deployDate
      if (typeof chkDate === 'undefined') {
        chkDate = currentDate
      }
      let start = '00:00'
      let end = '23:50'

      const inputDateObj = new Date(chkDate)
      const currentDateObj = new Date(currentDate)

      if (isToday(chkDate)) {
        //等於今天
        const now = new Date()
        const hours = now.getHours()
        const minutes = now.getMinutes()
        const roundedMinutes = Math.ceil(minutes / 10) * 10
        let startHour = hours
        let startMinute = roundedMinutes

        if (startMinute >= 60) {
          startHour += 1
          startMinute = startMinute - 60
        }
        // 格式化時間 HH:mm 格式
        start = `${startHour.toString().padStart(2, '0')}:${startMinute.toString().padStart(2, '0')}`
      } else if (inputDateObj > currentDateObj) {
        //大於今天
        start = '00:00'
      } else {
        //小於今天
        start = '00:00'
        end = '00:00'
      }

      let ops = {
        start: start,
        step: '00:10',
        end: end,
      }

      this.timePickOptions = ops
      return ops
    },
    alertErrorMsg(row) {
      let vm = this
      let msg = ''
      let pc = row.deployTaskProcess

      if (vm.getProcessHandler(pc, 'message')) {
        msg = pc[0]['message']
      }
      alert(msg)
    },
    getProcessHandler(process, key) {
      let isCheck = false
      if (process && process.length > 0) {
        let pc = process[0]
        isCheck = !!pc[key]
      }
      return isCheck
    },
    addData() {
      this.taskForm = defaultForm
      this.handleDialog()
    },
    handleDialog() {
      this.dialogVisible = !this.dialogVisible
    },
    checkIfEdited() {
      return JSON.stringify(this.originalFormData) !== JSON.stringify(this.taskForm)
    },
    convertEnvCodeToId(env) {
      let envId = 0
      switch (env) {
        case 'dev':
          envId = 1
          break
        case 'test':
          envId = 2
          break
        case 'prod':
          envId = 3
          break
        default:
      }
      return envId
    },
    async editData(row) {
      let vm = this
      let env = vm.convertEnvCodeToId(row.env)

      //取得儲存庫
      await vm.onRepoChange(row.repository)
      let branchs = vm.branchOptions
      let branch = vm.getDataByProperty(row.branch, branchs, 'name')

      let form = {
        ...row,
        repo: row.repository,
        env: env,
        deployTime: row.deployTime == null ? '00:00' : row.deployTime,
        branch: branch,
      }

      vm.taskForm = form
      //取得分支
      await this.getBranch(form.repo, form.branch.name, form.sha)
      //存原始表單資料，儲存時判斷有無編輯，避免直接執行api。
      // this.originalFormData = JSON.parse(JSON.stringify(this.taskForm));
      this.handleDialog()
    },
    async onRepoChange(val) {
      this.taskForm.branch = null
      await this.getBranchs(val)
      await this.GetAllServicesInRepository(val)
    },
    async onBranchChange(val) {
      this.taskForm.sha = val.commit.sha
      await this.getBranch(this.taskForm.repo, val.name, val.commit.sha)
    },
    getDataByProperty(id, obj, property) {
      return obj.find(option => option[property] === id)
    },
    async updated(row) {
      let vm = this

      let envId = vm.convertEnvCodeToId(row.env)
      let envDesc = vm.getDataByProperty(envId, vm.envOptions, 'id').desc
      if (
        !confirm(
          `請確認以下任務資訊：\r1，儲存庫：【${row.repo}】\r2，服務【${row.service}】\r3，分支【${row.branch}】\r4，目標環境【${envDesc}】\r請確認以上任務資訊無誤後送出執行。`
        )
      ) {
        return
      }

      vm.dialogLoading = true
      try {
        let payload = {
          mainId: row.id,
        }

        await doUpdated(payload)
        await vm.getList()
        vm.dialogLoading = false
        Message({
          message: '資料處理完成，請等待程序執行。',
          type: 'success',
          duration: 5 * 1000,
        })
      } catch (error) {
        vm.dialogLoading = false
      } finally {
        vm.dialogVisible = false
      }
    },
    async saveData() {
      let vm = this

      vm.$refs['form'].validate(async valid => {
        if (valid) {
          let form = vm.taskForm

          let envDesc = vm.getDataByProperty(form.env, vm.envOptions, 'id').desc
          if (
            !confirm(
              `請確認以下任務資訊：\r1，儲存庫：【${form.repo}】\r2，服務【${form.service}】\r3，分支【${form.branch.name}】\r4，目標環境【${envDesc}】\r請確認以上任務資訊無誤後送出執行。`
            )
          ) {
            return
          }

          // if (vm.taskForm.id) {
          //   let isEdit = vm.checkIfEdited();
          //   console.log('isEdit', isEdit);
          // }
          vm.dialogLoading = true
          try {
            let deployDate = vm.taskForm.deployType == 3 ? null : vm.taskForm.deployDate
            let payload = {
              ...form,
              branch: form.branch.name,
              deployDate: deployDate,
              triggeredBy: 'ita',
            }

            await saveTaskData(payload)
            await vm.getList()
            vm.dialogLoading = false
            Message({
              message: '資料處理完成，請等待程序執行。',
              type: 'success',
              duration: 5 * 1000,
            })
          } catch (error) {
            vm.dialogLoading = false
          } finally {
            vm.dialogVisible = false
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getBranch(repo, branch, sha) {
      let vm = this
      vm.branchLoading = true
      let resp = await getBranch({ repo, branch, sha })
      vm.branchInfo = resp.data
      vm.branchLoading = false
    },
    async getBranchs(repo) {
      if (!repo) {
        alert('請選擇儲存庫。')
        return
      }
      this.branchLoading = true
      let resp = await getBranchs({ repo })
      this.branchOptions = resp.data.branches
      this.branchLoading = false
    },
    async GetAllServicesInRepository(repo) {
      if (!repo) {
        alert('請選擇儲存庫。')
        return
      }
      this.branchLoading = true
      let resp = await GetAllServicesInRepository({ repo })
      this.serviceOptions = resp.data
      this.branchLoading = false
    },
    tokensToArray(t) {
      let ary = JSON.parse(t)
    },

    async getList() {
      this.listLoading = true
      let resp = await getDeployTaskList(this.listQuery)
      this.list = resp.data.data
      this.total = resp.data.total
      this.listLoading = false
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}

.notice-log-container .el-popover .el-popper .el-popover--plain {
  width: 500px;
}

.readonly-input input {
  background-color: gold;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
}

.custom-table th,
.custom-table td {
  /* padding: 0.75rem; */
  padding: 0.2rem;
  border: 1px solid #dee2e6;
  text-align: center;
}

.custom-table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  background-color: #f8f9fa;
}

.custom-table tbody + tbody {
  border-top: 2px solid #dee2e6;
}

.custom-table tbody tr:hover {
  background-color: #f2f2f2;
}

.process-checked {
  font-size: 18px;
  content: '';
  color: green;
  font-weight: bold;
}
</style>
